import {
  DocumentToBank,
  IApplicationDataToBank,
} from "../../slice/applicationDataToBankSlice/applicationDataToBankSlice";
import { api } from "../apiCore";
import { message } from "antd";
import { applicationDataToBankApi } from "./applicationBank.api";

export const documentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // загрузить документ
    uploadDocument: builder.mutation<
      { data: DocumentToBank },
      {
        body: FormData;
        applicationBankId: number;
        applicationId: number;
        section: keyof IApplicationDataToBank["documents"];
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/file`,
        method: "POST",
        body: value.body,
      }),
      // сохраняем результат мутации в кеш (pessimistic update)
      async onQueryStarted(
        { applicationBankId, applicationId, section },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data: uploadedDocument } = await queryFulfilled;
          // добавляем загруженный документ в кэш
          dispatch(
            applicationDataToBankApi.util.updateQueryData(
              "getApplicationDataToBank",
              { applicationBankId, applicationId },
              (draft) => {
                if (section !== "additionalDocument") {
                  const updatedDocuments = draft.documents[
                    section
                  ]?.documents.map((document) => {
                    // Если документ - паспорт физ. лица
                    if (uploadedDocument.data.member_passport_fl_id) {
                      // добавляем документ в кэш документ по id физ. лица
                      if (
                        uploadedDocument.data.member_passport_fl_id.toString() ===
                        document?.member_passport_fl_id?.toString()
                      ) {
                        return uploadedDocument.data;
                      }
                      return document;
                    }
                    // Если не паспорт, то добавляем документ в кэш по id типа документа
                    if (
                      uploadedDocument.data.id.toString() ===
                      document.id.toString()
                    ) {
                      return uploadedDocument.data;
                    }
                    return document;
                  });
                  // обновляем кэш списка документов
                  if (updatedDocuments && section in draft.documents) {
                    const sectionDocuments = draft.documents[section];
                    if (sectionDocuments !== undefined) {
                      sectionDocuments.documents = updatedDocuments;
                    }
                  }
                }
              }
            )
          );
          message.success("Документ успешно загружен");
        } catch (error) {
          //@ts-ignore
          if (error?.error?.data?.errors?.file[0]) {
            //@ts-ignore
            // да, такой обьект приходит, что поделать
            message.error(error?.error?.data?.errors?.file[0]);
          } else {
            message.error("Не удалось загрузить ");
          }
        }
      },
    }),

    uploadAdditionalDocument: builder.mutation<
      { data: DocumentToBank },
      {
        body: FormData;
        applicationBankId: number;
        applicationId: number;
        section: keyof IApplicationDataToBank["documents"];
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/file`,
        method: "POST",
        body: value.body,
      }),
      // сохраняем результат мутации в кеш (pessimistic update)
      async onQueryStarted(
        { applicationBankId, applicationId, section },
        { dispatch, queryFulfilled }
      ) {
        try {
          // результат запроса получаем
          const { data: uploadedDocument } = await queryFulfilled;
          // добавляем загруженный документ в кэш
          dispatch(
            applicationDataToBankApi.util.updateQueryData(
              "getApplicationDataToBank",
              { applicationBankId, applicationId },
              (draft) => {
                if (
                  section === "additionalDocument" &&
                  uploadedDocument.data.document
                ) {
                  const cacheDocuments = draft.documents.additionalDocument;
                  cacheDocuments?.documents[0].document?.push(
                    uploadedDocument.data.document
                  );
                  // обновляем кэш списка документов
                  if (section in draft.documents) {
                    const sectionDocuments = draft.documents[section];
                    if (
                      sectionDocuments !== undefined &&
                      cacheDocuments !== undefined
                    ) {
                      sectionDocuments.documents = cacheDocuments.documents;
                    }
                  }
                }
              }
            )
          );
          message.success("Документ успешно загружен");
        } catch (error) {
          //@ts-ignore
          if (error?.error?.data?.errors?.file[0]) {
            //@ts-ignore
            // да, такой обьект приходит, что поделать
            message.error(error?.error?.data?.errors?.file[0]);
          } else {
            message.error("Не удалось загрузить ");
          }
        }
      },
    }),
    deleteAdditionalDocument: builder.mutation<
      {},
      {
        applicationBankId: number;
        additionalDocumentId: number;
        applicationId: number;
      }
    >({
      query: (value) => ({
        url: `/auth/applications/system-bank/create-data-to-bank/${value.applicationBankId}/file/${value.additionalDocumentId}/delete`,
        method: "DELETE",
      }),
      // Удаляем заявку из кэша
      async onQueryStarted(
        { applicationBankId, additionalDocumentId, applicationId },
        { dispatch, queryFulfilled }
      ) {
        queryFulfilled.then(() =>
          // Делаем так чтобы удаление элемента происходило только при успехе с бэка
          dispatch(
            applicationDataToBankApi.util.updateQueryData(
              "getApplicationDataToBank",
              { applicationBankId, applicationId },
              (draft) => {
                try {
                  const filteredDocuments =
                    draft.documents.additionalDocument?.documents[0].document?.filter(
                      (document) => {
                        return document.id !== additionalDocumentId;
                      }
                    );
                  if (draft?.documents?.additionalDocument)
                    draft.documents.additionalDocument.documents[0].document =
                      filteredDocuments;
                } catch {
                  message.error("Что=то пошло не так");
                }
              }
            )
          )
        );
      },
    }),
  }),
});

export const {
  useUploadDocumentMutation,
  useUploadAdditionalDocumentMutation,
  useDeleteAdditionalDocumentMutation,
} = documentsApi;
